import { useEffect, useState } from "react";
import { Button, Label, Menu, Tab } from "semantic-ui-react";
// import "./styles.module.css";
import styles from "./styles.module.css";
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import AllTransactions from "./tables/AllTransactions";
import Modal from "../../../app/common/modals/Custom";
import { useNavigate } from "react-router-dom";
import { ReactComponent as WelcomeSvg } from "../../../assets/welcome.svg";
import { ReactComponent as PlaySvg } from "../../../assets/play.svg";
import { useStore } from "../../../app/stores/store";
import Loading from "../../../app/layout/Loading";
import { observer } from "mobx-react-lite";
import TablePlaceholder from "./tables/TablePlaceholder";
import { UserPermissions } from "../../../app/models/user";

const IndexPage = () => {
  const [modal, setModal] = useState("");
  const [openQuickSetup, setOpenQuickSetup] = useState(true);
  const navigate = useNavigate();
  const { commonStore, userStore } = useStore();
  const { loggedInUser, isAuthorized } = commonStore;
  const {
    dashLoadingInitial,
    notificationsLoading,
    getDashboardInfo,
    dashboardData,
    graphData,
    barData,
    pieChartData,
    transactions,
  } = userStore;

  const COLORS = ["#FFE8E8", "#32C36C", "red", "#FF8042"];
  const panes = [
    {
      menuItem: (
        <Menu.Item key={"all"}>
          <Label
            style={{
              fontFamily: "Montserrat",
              fontSize: "12px",
              background: "none",
              color: "rgb(4 4 4 / 87%)",
              padding: "0px",
            }}
          >
            Recent Transactions
          </Label>
        </Menu.Item>
      ),
      render: () =>
        dashLoadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllTransactions
            transactionList={transactions}
            // deleteProduct={deleteProduct}
          />
        ),
    },
  ];

  useEffect(() => {
    getDashboardInfo();
  }, [getDashboardInfo]);
  return (
    <div className={styles.page}>
      {(dashLoadingInitial === "loading" ||
        notificationsLoading === "loading") && <Loading />}
      {modal && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("1")}
        >
          <div className={styles.verifyAccountModal}>
            <h2>Activate Selling Permission</h2>

            <div className={styles.modalInfo}>
              {" "}
              <svg
                width="129"
                height="129"
                viewBox="0 0 129 129"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.4515 19.4512C30.9742 7.92866 46.9092 0.791504 64.5001 0.791504C82.0909 0.791504 98.0259 7.92866 109.549 19.4512C121.071 30.9739 128.208 46.909 128.208 64.4998C128.208 82.0907 121.071 98.0257 109.549 109.548C98.026 121.071 82.0909 128.208 64.5001 128.208C46.9092 128.208 30.9742 121.071 19.4515 109.548C7.92894 98.0257 0.791748 82.0907 0.791748 64.4998C0.791748 46.909 7.92897 30.9739 19.4515 19.4512ZM71.7397 34.0936C71.7397 30.0953 68.4984 26.854 64.5001 26.854C60.5018 26.854 57.2605 30.0953 57.2605 34.0936C57.2605 38.0919 60.5018 41.3332 64.5001 41.3332C68.4984 41.3332 71.7397 38.0919 71.7397 34.0936ZM60.1563 47.1248C56.9577 47.1248 54.3647 49.7179 54.3647 52.9165C54.3647 56.1151 56.9577 58.7082 60.1563 58.7082V87.6665H55.8126C52.6139 87.6665 50.0209 90.2595 50.0209 93.4582C50.0209 96.6568 52.6139 99.2498 55.8126 99.2498H76.0834C79.2821 99.2498 81.8751 96.6568 81.8751 93.4582C81.8751 90.2595 79.2821 87.6665 76.0834 87.6665H71.7397V52.9165C71.7397 49.7179 69.1466 47.1248 65.948 47.1248H60.1563Z"
                  fill="#F2994A"
                />
              </svg>
            </div>
            <div className={styles.welcomeText}>
              <p>
                Do you want to activate your permission for selling on AltPower?
              </p>
            </div>

            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.activate}
                onClick={() => setModal("1")}
              >
                <div className={styles.button}>
                  <span>Yes, activate</span>
                </div>
              </Button>
              <Button
                positive
                className={styles.negative}
                onClick={() => setModal("")}
              >
                <div className={styles.button}>
                  <span>No, cancel</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {modal && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("1")}
        >
          <div className={styles.verifyAccountModal}>
            <h2>Activate Selling Permission</h2>

            <div className={styles.modalInfo}>
              {" "}
              {/* <img src={star} className={styles.star} alt="wave" /> */}
              <svg
                width="224"
                height="224"
                viewBox="0 0 224 224"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <rect width="224" height="224" fill="url(#pattern0)" />
                <defs>
                  <pattern
                    id="pattern0"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                  >
                    <use
                      xlinkHref="#image0_2373_3861"
                      transform="scale(0.002)"
                    />
                  </pattern>
                  <image
                    id="image0_2373_3861"
                    width="500"
                    height="500"
                    xlinkHref="data:image/png;base64,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"
                  />
                </defs>
              </svg>
            </div>
            <div className={styles.welcomeText}>
              <p>Yay, you can now sell on AltPower!</p>
            </div>

            <div className={styles.next}>
              <Button
                positive
                className={styles.positive}
                onClick={() => setModal("1")}
              >
                <div className={styles.button}>
                  <span>Continue</span>
                  <PlaySvg />
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {modal && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("")}
        >
          <div className={styles.verifyAccountModal}>
            <h2>Account Verification</h2>
            <div className={styles.welcomeText}>
              <p>Welcome to AltPower.</p>
            </div>

            <div
              className={styles.loader}
              // style={{ marginTop: "20px", marginBottom: "50px" }}
            >
              <WelcomeSvg />
            </div>
            <div className={styles.next}>
              <Button
                positive
                className={styles.positive}
                onClick={() => setModal("1")}
              >
                <div className={styles.button}>
                  <span>Proceed to my account</span>
                  <PlaySvg />
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}
      <div className={styles.header}>
        Hey, {loggedInUser!.firstName}{" "}
        <span className={styles.handspan}>
          {/* <img src={handwave} className={styles.handwave} alt="wave" /> */}
          👋
        </span>{" "}
      </div>
      <div className={styles.required}>Welcome back!</div>
      {openQuickSetup && (
        <div className={styles.quickSetup}>
          <div className={styles.info}>
            Use this quick setup to complete your profile.
            <span onClick={() => setOpenQuickSetup(false)}>X</span>
          </div>
          {((loggedInUser && isAuthorized(UserPermissions.settings)) ||
            (loggedInUser && isAuthorized(UserPermissions.addUsers)) ||
            (loggedInUser && isAuthorized(UserPermissions.shipping))) && (
            <div className={styles.flexBoxes}>
              {loggedInUser && isAuthorized(UserPermissions.settings) && (
                <div
                  className={styles.flexBox}
                  onClick={() => navigate("/vendor/settings")}
                >
                  Change Password
                </div>
              )}
              {loggedInUser && isAuthorized(UserPermissions.addUsers) && (
                <div
                  className={styles.flexBox}
                  onClick={() => navigate("/vendor/users")}
                >
                  Create Sub-Admin
                </div>
              )}
              {loggedInUser && isAuthorized(UserPermissions.shipping) && (
                <div
                  className={styles.flexBox}
                  onClick={() => navigate("/vendor/shipping")}
                >
                  Set Shipping Fee
                </div>
              )}
              {loggedInUser && isAuthorized(UserPermissions.settings) && (
                <div
                  className={styles.flexBoxButton}
                  onClick={() => navigate("/vendor/terms")}
                >
                  Upload CAC Document
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <div className={styles.charts}>
        <div className={styles.box1}>
          {/* <img src={bank} className={styles.handwave} alt="wave" /> */}
          <div style={{ paddingBottom: "15px" }}>🏛</div>
          <div className={styles.header}>
            ₦{" "}
            {dashboardData && dashboardData.monthlyTransaction.totalTransaction}
          </div>
          <div style={{ paddingBottom: "10px" }}></div>
          <div className={styles.required}>All Payments made</div>
          <div style={{ paddingBottom: "15px" }}></div>
          <hr />
          <div className={styles.lineIndicator}>
            <div className={styles.lineIndicatorHeader}>
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 3V21"
                  stroke="black"
                  strokeOpacity="0.95"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M21 21H3"
                  stroke="black"
                  strokeOpacity="0.95"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7 16L12.25 10.75L15.75 14.25L21 9"
                  stroke="black"
                  strokeOpacity="0.95"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Transactions</span>
            </div>
            <div className={styles.periodDropDown}>
              Monthly{" "}
              <span>
                <svg
                  width="8"
                  height="5"
                  viewBox="0 0 8 5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L4 4L7 1"
                    stroke="#32C36C"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
          </div>
          {/* <ResponsiveContainer width="100%" height="55%">
            <LineChart
              width={300}
              height={100}
              data={linedata}
              margin={{
                top: 20,
                right: 20,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line
                type="monotone"
                dataKey="pv"
                stroke="#32C36C"
                activeDot={{ r: 8 }}
              />
            </LineChart>
          </ResponsiveContainer> */}
          <div style={{ width: "100%", height: 200 }}>
            <ResponsiveContainer>
              <AreaChart data={graphData}>
                {/* <CartesianGrid strokeDasharray='3 3' /> */}
                <XAxis
                  dataKey="name"
                  axisLine={false}
                  tickLine={false}
                  padding={{ left: 20 }}
                  tickSize={3}
                  // style={{
                  //   fontSize: "14px",
                  //   fontFamily: "Montserrat",
                  //   fontWeight: "100",
                  // }}
                />
                <YAxis axisLine={false} tickLine={false} />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey="amount"
                  stroke="#35DB9F"
                  fill="rgba(53, 219, 159, 0.24)"
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className={styles.box2}>
          <div className={styles.products}>
            <div style={{ display: "flex" }}>
              <svg
                width="42"
                height="42"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="26" cy="26" r="26" fill="#DFF2E7" />
                <path
                  d="M13.1961 16.0381C12.9684 16.0372 12.7499 16.1273 12.5889 16.2882C12.4281 16.4492 12.3379 16.6676 12.3389 16.8951V21.7794C12.3393 22.0062 12.43 22.2235 12.5908 22.3832C12.7515 22.5431 12.9693 22.6325 13.1961 22.6315H14.1033V37.0263C14.1041 37.2531 14.1952 37.4702 14.3562 37.6297C14.5174 37.7892 14.7353 37.8782 14.9621 37.8769H37.0461C37.2725 37.8779 37.4899 37.7887 37.6508 37.6291C37.8115 37.4696 37.9024 37.2529 37.9033 37.0264V22.6315H38.8105C39.036 22.6308 39.2521 22.5406 39.4114 22.3809C39.5707 22.2212 39.6605 22.0051 39.6609 21.7795V16.8952C39.6618 16.6687 39.5727 16.4513 39.4131 16.2906C39.2536 16.1298 39.0369 16.039 38.8105 16.0381L13.1961 16.0381ZM14.0465 17.7474H21.7874V20.9226H14.0465V17.7474ZM23.495 17.7474H28.5111V27.0311L26.3882 25.9522C26.1463 25.8302 25.8612 25.8302 25.6193 25.9522L23.4949 27.0311L23.495 17.7474ZM30.2207 17.7474H37.9533V20.9226H30.2207V17.7474ZM15.8127 22.6317H21.7874V28.4235V28.4233C21.787 28.7204 21.9412 28.9962 22.1943 29.1518C22.4474 29.3073 22.7632 29.32 23.0279 29.1855L26.003 27.673L28.978 29.1855C29.0798 29.2377 29.1909 29.2688 29.3048 29.2772C29.3332 29.2793 29.3616 29.2796 29.39 29.2789C29.6126 29.2728 29.8242 29.18 29.9793 29.0201C30.1344 28.8602 30.221 28.6461 30.2204 28.4234V22.6316H36.1951V36.1692H15.8119L15.8127 22.6317Z"
                  fill="#0A8000"
                />
              </svg>
              <div style={{ marginLeft: "20px" }}>
                <div className={styles.header}>
                  {dashboardData && dashboardData.vendorProducts.allProducts}
                </div>
                <div className={styles.required}>All Products</div>
              </div>
            </div>
            <div style={{ paddingBottom: "10px" }}></div>
            <hr />
            <div style={{ paddingBottom: "20px" }}></div>
            <ResponsiveContainer
              width="100%"
              height="60%"
              className={styles.barContainer}
            >
              <BarChart width={100} height={40} data={barData}>
                {/* <CartesianGrid strokeDasharray="3 3" /> */}
                <XAxis dataKey="name" axisLine={false} tickLine={false} />
                <YAxis axisLine={false} tickLine={false} />
                {/* <Tooltip /> */}
                {/* <Legend /> */}
                <Bar dataKey="uv" fill={COLORS[barData.length % COLORS.length]}>
                  {barData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className={styles.orders}>
            <PieChart width={170} height={170}>
              <Pie
                cx="50%"
                cy="50%"
                data={pieChartData}
                dataKey="orders"
                outerRadius={65}
                innerRadius={45}
                fill="#8884d8"
              >
                {pieChartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <g>
                <text x={"50%"} y={"50%"} dy={4} textAnchor="middle">
                  {dashboardData && dashboardData.vendorOrder.totalOrder}
                </text>
              </g>
              <g>
                <text
                  x={"50%"}
                  y={"50%"}
                  dy={18}
                  textAnchor="middle"
                  style={{ fontSize: "6px", fontFamily: "Montserrat" }}
                >
                  {"Total orders made"}
                </text>
              </g>
            </PieChart>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "20px",
              }}
            >
              <div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <svg
                    width="37"
                    height="37"
                    viewBox="0 0 37 37"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="18.5" cy="18.5" r="18.5" fill="#32C36C" />
                    <path
                      d="M17.0393 26.2695C17.0393 27.2414 16.2514 28.0293 15.2796 28.0293C14.3077 28.0293 13.5198 27.2414 13.5198 26.2695C13.5198 25.2977 14.3077 24.5098 15.2796 24.5098C16.2514 24.5098 17.0393 25.2977 17.0393 26.2695Z"
                      fill="white"
                    />
                    <path
                      d="M25.8386 26.2695C25.8386 27.2414 25.0507 28.0293 24.0789 28.0293C23.107 28.0293 22.3191 27.2414 22.3191 26.2695C22.3191 25.2977 23.107 24.5098 24.0789 24.5098C25.0507 24.5098 25.8386 25.2977 25.8386 26.2695Z"
                      fill="white"
                    />
                    <path
                      d="M14.6195 23.41H24.9583V22.0902H15.9392V20.7703H24.9583C25.0962 20.7702 25.2307 20.7269 25.3427 20.6464C25.4548 20.5659 25.5388 20.4523 25.5829 20.3216L27.3427 15.0422L26.0932 14.6287L24.483 19.4593H15.7633L13.4404 10.6514H10V11.9712H12.4285L14.6194 20.1983L14.6195 23.41Z"
                      fill="white"
                    />
                  </svg>
                  <div style={{ marginLeft: "20px" }}>
                    <div className={styles.header}>
                      {dashboardData && dashboardData.vendorOrder.cancelled}
                    </div>
                    <div className={styles.appleFont}>Cancelled</div>
                  </div>
                </div>
                <div style={{ display: "flex", paddingTop: "20px" }}>
                  <svg
                    width="37"
                    height="37"
                    viewBox="0 0 37 37"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="18.5" cy="18.5" r="18.5" fill="#FFE8E8" />
                    <path
                      d="M17.0393 26.2695C17.0393 27.2414 16.2514 28.0293 15.2796 28.0293C14.3077 28.0293 13.5198 27.2414 13.5198 26.2695C13.5198 25.2977 14.3077 24.5098 15.2796 24.5098C16.2514 24.5098 17.0393 25.2977 17.0393 26.2695Z"
                      fill="#000000"
                    />
                    <path
                      d="M25.8386 26.2695C25.8386 27.2414 25.0507 28.0293 24.0789 28.0293C23.107 28.0293 22.3191 27.2414 22.3191 26.2695C22.3191 25.2977 23.107 24.5098 24.0789 24.5098C25.0507 24.5098 25.8386 25.2977 25.8386 26.2695Z"
                      fill="#000000"
                    />
                    <path
                      d="M14.6195 23.41H24.9583V22.0902H15.9392V20.7703H24.9583C25.0962 20.7702 25.2307 20.7269 25.3427 20.6464C25.4548 20.5659 25.5388 20.4523 25.5829 20.3216L27.3427 15.0422L26.0932 14.6287L24.483 19.4593H15.7633L13.4404 10.6514H10V11.9712H12.4285L14.6194 20.1983L14.6195 23.41Z"
                      fill="#000000"
                    />
                  </svg>
                  <div style={{ marginLeft: "20px" }}>
                    <div className={styles.header}>
                      {dashboardData && dashboardData.vendorOrder.returned}
                    </div>
                    <div className={styles.appleFont}>Returned</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.tableSection}>
        <div className="section">
          <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
        </div>
      </div>
    </div>
  );
};

export default observer(IndexPage);
